import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import { Table, Button } from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';

import Inputmask from 'inputmask';

var Config = require('../../../config');

class ModalIncidents extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveIncident = this.saveIncident.bind(this);
		this.onManifestationChange = this.onManifestationChange.bind(this);

		this.addIncident = this.addIncident.bind(this);
		this.onHourChange = this.onHourChange.bind(this);
		this.onPrint = this.onPrint.bind(this);

		this.state = {
		    show: false,
		    incidents_manifestations:[],
		    incidents_imputability:[],
		    incidents_severity:[],
		    timestamp_date:"",
		    timestamp_hour:"",
		    incident_severity:"",
		    incident_imputability:"",
		    moment_incidents:[],
		    moment_incident:"",
		    offers_id:"",
		    manifestation_ids:[],
		    observations:"",

			incident_ids:[],
			incident_type:{
				id:"",
				text:""
			},
			incidents_type:[],
			incidents_list:[],
			caller_id:"",
			saved:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);

		
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(offer_id, incident_id, caller_id) {
		this.setState({ 
			caller_id:caller_id,
			show: true,
		    timestamp_date:"",
		    timestamp_hour:"",
		    incident_severity:"",
		    incident_imputability:"",
		    moment_incidents:[],
		    moment_incident:"",
		    offers_id:offer_id,
		    incident_id: incident_id,
		    method_form:"post",
		    manifestation_ids:[],
		    observations:"",

		    incident_ids:[],
			incident_type:{
				id:"",
				text:""
			},
			incidents_type:[],
			incidents_list:[]

		});
							
		fetch(Config.default.apiGateway.URL+'lookups?type=moment_incident&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      moment_incidents: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'incidents?option=EXTRACTION', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				incidents_type:response
			})

			
		})

		fetch(Config.default.apiGateway.URL+'incidents?option=INCIDENT_IMPUTABILIDAD',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      incidents_imputability: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'incidents?option=INCIDENT_TGRAVEDAD',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      incidents_severity: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'incidents?option=INCIDENT_MCLINICAS',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      incidents_manifestations: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);
			this.setState({timestamp_date:aux[0], timestamp_hour:hours});
		})


		if(incident_id !== 0){
			fetch(Config.default.apiGateway.URL+'incidents_extraction?id='+incident_id, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => res.json())
			.then(response => {
				this.setData(response)
			})
		}

		setTimeout(function(){
			var selector = document.getElementById("timestamp_hour");
			var im = new Inputmask("__:__");
			im.mask(selector);
		}, 500)
		
	}

	setData(incidents){

		this.setState({
			moment_incident: incidents.incidents_extraction.moment_incident,
			manifestation_ids: incidents.manifestation_ids,
			incident_imputability: incidents.incidents_extraction.imputability_incident_id,
			incident_severity: incidents.incidents_extraction.severity_incident_id,
			observations: incidents.incidents_extraction.observations,
			method_form:"put",

			incident_ids: incidents.incident_ids,
		})		

		this.state.incidents_type.map(function (v,i){
			if(this.state.incident_ids.indexOf(v.id) !== -1){
				var incident = {};
				incident.id = v.id;
				incident.text = v.name;
				this.setState({
					incidents_list: [...this.state.incidents_list, incident]
				})
			}
		}.bind(this))

	}

	onManifestationChange(e){
		if(e.target.checked){
			this.setState({
				manifestation_ids: [...this.state.manifestation_ids, parseInt(e.target.value,10)]
			});
		}else{
			var array = [...this.state.manifestation_ids]; 
			var index = array.indexOf(parseInt(e.target.value));
			array.splice(index, 1);

			this.setState({manifestation_ids: array});
		}	
	}

	saveIncident(){
		
		if(this.isValidForm()){
			
			var obj = {};

			obj.offers_id 		= this.state.offers_id;
			obj.moment_incident = this.state.moment_incident;
			var date = moment(this.state.timestamp_date, 'DD-MM-YYYY');
			var hour = moment(this.state.timestamp_hour, 'h:mm a');
			obj.timestamp_date = date.format('MM-DD-YYYY');
			obj.timestamp_hour = this.state.timestamp_hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
			obj.severity_incident_id 	 = parseInt(this.state.incident_severity,10);
			obj.imputability_incident_id = this.state.incident_imputability;
			obj.observations 			 = this.state.observations;
			obj.manifestation_ids 		 = this.state.manifestation_ids;
			obj.incident_ids 			 = this.state.incident_ids;

			var incident_id = null;
			/* listo */
			if(this.state.method_form === 'put')
				incident_id = '/'+this.state.incident_id;
			else
				incident_id = '';

			if(obj.timestamp_hour === "Invalid date" || obj.timestamp_hour === "Fecha inválida"){
				swal("Error", "Hora invalida", 'error');
			}else if(obj.incident_ids.length === 0){
				swal('Error', 'Debe agregar por lo menos un incidente', 'error');
			}else{
				this.waiting_modal.handleShow('Generando...');			
				fetch(Config.default.apiGateway.URL+'incidents_extraction'+incident_id, {
					method:this.state.method_form,
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json;charset=UTF-8'
					})
				})
				.then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then(function(result) {
							swal('¡Error!', result, 'error');
						});
					}
				})
				.then(response => {
					if(response !== undefined){
						this.setState({ saved: true});
						swal({
							title: '¡Buen Trabajo!',
							text: '',
							type: 'info'
						}, () => {
							this.waiting_modal.handleClose();
						});
					    //this.props.refresh();
					}
				})
			}
			
		}else{
			swal('Error', 'Campos Incompletos','error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const ctrls = document.querySelectorAll('input,select');
	    let isFormValid = true;

	    ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			if (control.value === "") {
		        if(control !== null){
		            control.classList.add('error');
		        }
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
			        	control.classList.remove('error');
			    	}
		    	}
				res = true;
			}
		}

		return res;
	}

	handleChange = (event) => {
		this.setState({[event.target.name]:event.target.value});
	}

	//Evento para checkbox
	handleCheck = (event) => {
	    this.setState({
	      [event.target.name]: event.target.checked
	    });
	}

	onIncidentSelected = (e)=>{
		//this.handleChange(e);
		const incident = this.state[e.target.name];	
		incident.id    = e.target.value;
		incident.text  = e.target.options[e.target.selectedIndex].text

		this.setState({
			incident_type : incident
		});
	}

	addIncident(){
		if(this.state.incident_type.id !== undefined && this.state.incident_type.id !== ""){
			
			var flag = false;

			for (var i = 0; i < this.state.incidents_list.length; i++) {

				if (this.state.incidents_list[i].text === this.state.incident_type.text) {
					flag = true;
					break
				};
			};
			
			if(flag === true){
				swal('¡El Tipo de incidente no se puede agregar!', '¡Ya se ingreso un incidente con ese tipo!', 'error');

				this.setState({
					incident_type:{id:"", text:""}
				});
			}else{
				var obj = this.state.incident_type;


				if(this.state.incidents_list.length < 3){
					this.setState({
						incident_type:{id:"", text:""},
						incidents_list: [...this.state.incidents_list, obj],
						incident_ids: [...this.state.incident_ids, parseInt(obj.id,10)]
					})

				}else{
					swal('info', "Solo esta permitido agregar 3 tipos de incidentes", 'info')
				}	
			}
		
		}	
	}

	removeIncidetFromList(indice){
		var array = [...this.state.incidents_list];
		array.splice(indice, 1);
		var ids = [...this.state.incident_ids];
		var index = -1;
		var aux = [];
		array.map((a, i)=>{
			var index = ids.findIndex(obj => obj === a.id);
			if(index !== -1){
				aux.push(ids[index]);
			}
		})
		ids = aux;

		this.setState({
			incidents_list: array,
			incident_ids: ids
		});
	}

	async onPrint(e){
		e.preventDefault();
	
		this.waiting_modal.handleShow('Imprimiendo...');
			
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.state.offers_id;
		obj.file_type = "incidents_extraction";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		this.waiting_modal.handleClose();
		if(document !== undefined){				
			this.setState({ show: false});			
		}

	}
	
	onHourChange(e){
		var hour = moment(e.target.value, 'h:mm a');

		if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
			document.getElementById(e.target.id).classList.add("error");
			document.getElementById(e.target.name).style.borderColor = "red";
		}else{
			document.getElementById(e.target.name).style.borderColor = "#ccc";
			document.getElementById(e.target.id).classList.remove("error");
		}

		this.validateInput(e);
		this.setState({
			timestamp_hour:e.target.value
		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
      				form.elements[index].removeAttribute("style");      				
  					if(form.elements[index + 1].getAttribute("disabled") === null){	
    					if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
							form.elements[index + 1].focus();
							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
    					
    					}else{
    						form.elements[index + 1].focus();
    					}
    					
  					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
      				
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_incidents.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<form noValidate>
			        	<div className="row" style={{margin:"10px"}}>
			        		{/*MOMENTO DEL INCIENTE*/}
			        		<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.incident_moment')}:</span>
			 					</div>
			 					<div className="col-xs-8">
			 						<select className="form-control" value={ this.state.moment_incident.toLowerCase() || "" }  required
									onChange={ this.handleChange } name="moment_incident" id="moment_incident" onKeyPress={(e) => this.validateInput(e)}>
									<option value="" disabled >Seleccionar...</option>
									{
										this.state.moment_incidents.map(function(t,index) {
											return <option key={index}  value={t.key}>{t.name} </option>
										})
									}
									</select>
								</div>
							</div>
							{/*CATEGORIA*/}
							<div className="form-group col-xs-12">
								<div className="col-xs-4">
			 						<span >Incidente:</span>
			 					</div>
			 					<div className="col-xs-8" >
				 										
										<div className="form-group col-xs-10" style={{paddingLeft:"0px"}}>
											<select className="form-control" value={ this.state.incident_type.id || ""} onKeyPress={(e) => this.validateInput(e)}
												onChange={ this.onIncidentSelected } name="incident_type" id="incident_type" >
												<option value="" disabled>Seleccionar...</option>
												{
													this.state.incidents_type.map(function(t) {
														return <option key={t.id} value={t.id} >{t.name}</option>;
													})
												}
											</select>
										</div>
										<div className="col-xs-2" style={{paddingRigth:"0px"}}>
											<FloatingActionButton className="btn-plus"  mini={true} style={{float:"right"}}
												 onClick={this.addIncident} iconStyle={{height: 25, width: 25}}>
											  <ContentAdd/>
											</FloatingActionButton>
										</div>

									<div className="col-xs-12">
										<Table responsive hover>
											<thead>
												<tr>
													<th>{t('content.extractions.incidents.category')}</th>
													<th>{t('content.extractions.incidents.type')}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
											{
												this.state.incidents_list.map((v, i) => (
													<tr key={i}>
														<td>Extracción</td>
														<td>{v.text}</td>
														<td>
															<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} onClick={(e)=>this.removeIncidetFromList(i, e)}>
																<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
															</Button>
														</td>
													</tr>
												))
											}
											</tbody>
										</Table>
									</div>
								</div>		
							</div>

							{/*FECHA*/}
							<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.date')}:</span>
			 					</div>
			 					<div className="col-xs-4">
			 						<input className="form-control" disabled value={this.state.timestamp_date}/>
								</div>
								<div className="col-xs-4">
									<input id="timestamp_hour" name="timestamp_hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
										data-inputmask-placeholder="-" value={this.state.timestamp_hour || ""} onChange={this.onHourChange}
										  className="form-control" onKeyPress={(e) => this.validateInput(e)}/>

			 						{/*<input type="time" className="form-control hour-input" onChange={this.onHourChange} 
										onBlur={this.onHourChange} value={this.state.timestamp_hour}/>*/}
								</div>
							</div>
							{/*MANIFESTACION CLINICA*/}
							<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.clinic_manifestation')}:</span>
			 					</div>
			 					<div className="col-xs-8 form-group">
				 					<div className="border-max-height" style={{maxHeight: "200px",overflowY: "scroll",padding:"10px"}}>
				 						{this.state.incidents_manifestations.map(function(t,index) {
												return <div key={index}>
															<input className="form-check-input" type="checkbox" name={t.incident_type} onKeyPress={(e) => this.validateInput(e)}
															onChange={this.onManifestationChange} value={t.id} 
															checked={this.state.manifestation_ids.indexOf(t.id) !== -1 ? true : false}
															/>
												        	<span style={{marginLeft:"5px",fontSize:'.75em'}}>{t.name}</span>
														</div>
										}.bind(this))}
									</div>
								</div>
							</div>
							{/*GRAVEDAD*/}
							<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.severity')}:</span>
			 					</div>
			 					<div className="col-xs-8">
			 						<select className="form-control" value={ this.state.incident_severity || ""} onKeyPress={(e) => this.validateInput(e)}
									onChange={ this.handleChange } name="incident_severity" id="incident_severity">
									<option value="" disabled >Seleccionar...</option>
									{
										this.state.incidents_severity.map(function(t,index) {
											return <option key={index}  value={t.id}>{t.name} </option>
										})
									}
									</select>
								</div>
							</div>
							{/*IMPUTABILIDAD*/}
							<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.imputability')}:</span>
			 					</div>
			 					<div className="col-xs-8">
			 						<select className="form-control" value={ this.state.incident_imputability || "" } onKeyPress={(e) => this.validateInput(e)}
									onChange={ this.handleChange } name="incident_imputability" id="incident_imputability">
									<option value="" disabled >Seleccionar...</option>
									{
										this.state.incidents_imputability.map(function(t,index) {
											return <option key={index}  value={t.id}>{t.name} </option>
										})
									}
									</select>
								</div>
							</div>
							{/*OBSERVACIONES*/}
							<div className="form-group col-xs-12">
			 					<div className="col-xs-4" >
			 						<span >{t('content.modal_incidents.observations')}:</span>
			 					</div>
			 					<div className="col-xs-8">
			 						<textarea className="form-control-min" value={this.state.observations} 
			 							style={{height:"70px",width:"100%",resize:"none"}}
			 							onChange={this.handleChange} onKeyPress={(e) => this.validateInput(e)}
									 	name="observations"/>
								</div>
							</div>
							
					    </div>
				    </form>
		        </Modal.Body>
		        <Modal.Footer>
					{(this.state.saved || this.state.incident_id !== '0')&& <FlatButton primary={true} label={t('content.generics.buttons.print')} 
						onClick={this.onPrint}/>}
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveIncident}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
	      	</div>
		);
	}
}

export default translate('translations')(ModalIncidents);